import './style.scss';

import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button, ButtonGroup, Checkbox, Dropdown, Icon, Popup } from 'semantic-ui-react';
import {
  selectRotationMode,
  selectFixedRotationAngle,
  setRotationMode,
  setFixedRotationAngle,
} from 'app/redux/rotationHistory/reducer';
import type { FixedRotationAngle } from 'app/redux/rotationHistory/reducer';

const FIXED_ROTATION_ANGLE_OPTIONS = [
  { key: '0', text: '0°', value: 0 },
  { key: '90', text: '90°', value: 90 },
  { key: '180', text: '180°', value: 180 },
  { key: '270', text: '270°', value: 270 },
];

const ImageRotationConfiguration: React.FC = () => {
  const dispatch = useDispatch();
  const rotationMode = useSelector(selectRotationMode);
  const fixedRotationAngle = useSelector(selectFixedRotationAngle);

  const handleAutomaticRotationToggle = useCallback(() => {
    dispatch(
      setRotationMode({ rotationMode: rotationMode === 'automatic' ? 'none' : 'automatic' })
    );
  }, [dispatch, rotationMode]);

  const handleFixedRotationToggle = useCallback(() => {
    dispatch(setRotationMode({ rotationMode: rotationMode === 'fixed' ? 'none' : 'fixed' }));
  }, [dispatch, rotationMode]);

  const handleFixedRotationAngleChange = useCallback(
    (_e: React.SyntheticEvent, { value }: { value: FixedRotationAngle }) => {
      dispatch(setFixedRotationAngle({ fixedRotationAngle: value }));
    },
    [dispatch]
  );

  return (
    <div className="image-rotation-configuration">
      <div className="image-rotation-configuration__row">
        <Button onClick={handleAutomaticRotationToggle} compact icon labelPosition="left">
          <Icon className="flex center">
            <Checkbox checked={rotationMode === 'automatic'} />
          </Icon>
          <FormattedMessage id="account.configuration.rotation.automatic_rotation" />
        </Button>
        <Popup
          trigger={<Icon name="info" circular />}
          content={
            <FormattedMessage id="account.configuration.rotation.automatic_rotation.explain" />
          }
          on="hover"
        />
      </div>
      <div className="image-rotation-configuration__row">
        <ButtonGroup compact>
          <Button onClick={handleFixedRotationToggle} compact icon labelPosition="left">
            <Icon className="flex center">
              <Checkbox checked={rotationMode === 'fixed'} />
            </Icon>
            <FormattedMessage id="account.configuration.rotation.fixed_rotation" />
          </Button>

          <Button
            style={{ padding: 0, display: 'flex' }}
            compact
            disabled={rotationMode !== 'fixed'}
          >
            <Dropdown
              disabled={rotationMode !== 'fixed'}
              compact
              className="selection"
              options={FIXED_ROTATION_ANGLE_OPTIONS}
              value={fixedRotationAngle}
              onChange={handleFixedRotationAngleChange}
            />
          </Button>
        </ButtonGroup>
      </div>
    </div>
  );
};

export default ImageRotationConfiguration;
